// ANANT SAMACHAR — All News Showcase (public grid + classified banners like CityPro Shops)
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';

export default function AnantSamacharAllNews() {
  const [items, setItems] = useState([]);
  const [ads, setAds] = useState([]);
  const [city, setCity] = useState('');
  const [type, setType] = useState('');
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const params = { limit: 200 };
      if (city) params.city = city;
      if (type) params.content_type = type;
      const [c, a] = await Promise.all([
        api.get('/asn/content', { params }),
        api.get('/asn/ads/live', { params: city ? { city } : {} }),
      ]);
      setItems(c.data?.content || []);
      setAds(a.data?.ads || []);
    } catch { /* silent */ }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [city, type]);
  const filtered = items.filter((n) => !q || (n.title + ' ' + (n.body || '')).toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="min-h-screen pt-20 bg-gradient-to-b from-blue-950 via-slate-950 to-red-950 text-white" data-testid="asn-allnews">
      <div className="max-w-6xl mx-auto px-3 pb-16">
        <div className="flex items-center gap-2 mb-3">
          <Link to="/asn" className="text-xs text-slate-400 hover:text-white">← Back to ASN</Link>
        </div>
        <h1 className="text-2xl sm:text-3xl font-black tracking-tight">All News · Anant Samachar Network</h1>
        <p className="text-[11px] opacity-70 mb-3">Discover all reporter-published news across cities · classified ads at top</p>

        {/* Classified Ads */}
        {ads.length > 0 && (
          <div className="rounded-2xl border-2 border-amber-400/50 bg-gradient-to-r from-amber-950/40 to-red-950/40 p-3 mb-3" data-testid="asn-allnews-ads">
            <div className="text-[10px] uppercase tracking-widest text-amber-300 font-black mb-2">📣 Classified Ads</div>
            <div className="flex gap-2 overflow-x-auto pb-1">
              {ads.map((ad) => (
                <a key={ad.id} href={ad.link_url || '#'} target="_blank" rel="noreferrer"
                   data-testid={`asn-ad-${ad.id}`}
                   className="shrink-0 w-64 sm:w-80 rounded-xl overflow-hidden border border-amber-400/40 hover:border-amber-400 transition">
                  <div className="aspect-[3/1] bg-slate-900 bg-cover bg-center" style={{ backgroundImage: `url(${ad.image_url || ad.card_image_url})` }} />
                  <div className="p-2 text-xs font-black bg-slate-900/80">{ad.title}</div>
                </a>
              ))}
            </div>
          </div>
        )}

        {/* Filters */}
        <div className="flex flex-wrap gap-2 mb-3">
          <input placeholder="🔎 Search title / body" value={q} onChange={(e) => setQ(e.target.value)} data-testid="asn-allnews-q"
                 className="flex-1 min-w-[180px] px-2 py-1.5 rounded bg-slate-800 border border-slate-700 text-xs" />
          <input placeholder="🌆 City" value={city} onChange={(e) => setCity(e.target.value)} data-testid="asn-allnews-city"
                 className="px-2 py-1.5 rounded bg-slate-800 border border-slate-700 text-xs" />
          <select value={type} onChange={(e) => setType(e.target.value)} data-testid="asn-allnews-type"
                  className="px-2 py-1.5 rounded bg-slate-800 border border-slate-700 text-xs">
            <option value="">— All types —</option>
            <option value="news">News</option>
            <option value="ad">Ad</option>
            <option value="event">Event</option>
            <option value="notice">Notice</option>
          </select>
        </div>

        {loading && <div className="text-center opacity-70 py-8">⏳ Loading news…</div>}

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {filtered.map((n) => (
            <Link key={n.id} to={`/asn/news/${n.id}`} data-testid={`asn-allnews-item-${n.id}`}
                  className="rounded-2xl overflow-hidden border border-slate-700 bg-slate-900/70 hover:border-blue-400 hover:shadow-lg hover:shadow-blue-500/20 transition-all">
              {n.card_image_url && (
                <div className="aspect-video bg-slate-800 bg-cover bg-center" style={{ backgroundImage: `url(${n.card_image_url})` }} />
              )}
              <div className="p-3">
                <div className="text-[10px] flex gap-1 items-center mb-1">
                  <span className="px-1.5 py-0.5 rounded bg-blue-500/25 text-blue-300 font-black uppercase">{n.content_type}</span>
                  <span className="opacity-70">{n.city || 'India'} · {new Date(n.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}</span>
                </div>
                <div className="font-black text-sm leading-tight mb-1">{n.title}</div>
                <div className="text-[11px] opacity-80 line-clamp-3">{(n.body || '').slice(0, 160)}{(n.body || '').length > 160 ? '…' : ''}</div>
              </div>
            </Link>
          ))}
        </div>
        {!loading && filtered.length === 0 && <div className="text-center opacity-60 py-10 text-sm">Koi news nahi mili · filters clear karke try karo</div>}
      </div>
    </div>
  );
}
